module.exports = __webpack_public_path__ + "media/icons/maximize-90574224.svg";